export function retrieveTimings(names) {
    const timings = new Map();
    names.forEach((name) => {
        const storedTiming = sessionStorage.getItem(name);
        if (storedTiming) {
            timings.set(name, JSON.parse(storedTiming));
        }
    });
    return timings;
}
export function storeTiming(name, timing) {
    sessionStorage.setItem(name, JSON.stringify(timing));
}
